module.exports = {"id":"143745","name":"Arda Turan","rating":"81","photo":"./data/images/photos/4/143745.png","club":{"name":"Medipol Başakşehir","logo":"./data/images/clubs/MedipolBasaksehir.png"},"positions":["MC","AD","AG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ArdaTuran0.json
// module id = 458
// module chunks = 0